import { Link } from "react-router-dom";

import "./notFound.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";

function NotFound() {
  return (
    <div className="container-fluid p-0 pagina-notfound">
      <SEO
        title="Página Não Encontrada | Antonio Saldanha Advocacia"
        description="A página que você está procurando não existe ou foi movida."
        canonical="https://antoniosaldanhaadvocacia.com.br/404"
      />

      <Navbar />

      <main className="py-5 d-flex align-items-center justify-content-center min-vh-60">
        <div className="text-center p-4 p-md-5 max-w-600 bg-white rounded-3 shadow-sm border">
          <span className="badge badge-dourado fs-6 mb-3">Erro 404</span>
          <h1 className="titulos-secoes mb-3">Página Não Encontrada (404)</h1>
          <p className="text-secondary font-sm mb-4">
            A página que você tentou acessar não existe ou foi alterada.
          </p>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <Link to="/" className="btn botao-dourado">
              Voltar para a Página Inicial
            </Link>
            <Link to="/#contato" className="btn botao-escuro-padrao">
              Fale Conosco
            </Link>
          </div>
        </div>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default NotFound;
